import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import projectService from "../services/projectService";
import InnerPageLayout from "../components/Layout/InnerPageLayout";
import BreadCrumb from "../components/Breadcrumb/BreadCrumb";
import ProjectOverview from "../components/Projects/ProjectOverview";
import ProjectRequirement from "../components/Projects/ProjectRequirement";
import ProjectResult from "../components/Projects/ProjectResult";
import { useContentAvailability } from "../utils/contentAvailability";

export default function ProjectDetails() {
  const { hasCaseStudies } = useContentAvailability();
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await projectService.getProjectBySlug(slug);

        // Handle response structure (response.data or direct response)
        const projectData = data.data || data;

        if (projectData) {
          setProject(projectData);
        } else {
          setError("Project not found");
        }
      } catch (error) {
        console.error("Error fetching project details:", error);
        setError("Failed to load project details");
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchProjectDetails();
    }
  }, [slug]);

  // Return null if case studies are not available
  if (!hasCaseStudies) {
    return null;
  }

  if (loading) {
    return (
      <InnerPageLayout>
        <div className="flex h-[50vh] items-center justify-center">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-purple"></div>
            <p className="text-white mt-4">Loading project...</p>
          </div>
        </div>
      </InnerPageLayout>
    );
  }

  if (error || !project) {
    return (
      <InnerPageLayout>
        <div className="flex h-[50vh] items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl text-white mb-2">Project Not Found</h2>
            <p className="text-gray-400">{error || "The requested project could not be found."}</p>
          </div>
        </div>
      </InnerPageLayout>
    );
  }

  const pageTitle = project.title || "Project Details";

  return (
    <InnerPageLayout>
      <BreadCrumb
        pageTitle={pageTitle}
        items={[
          { label: "Case Studies", path: "/case-studies" },
          { label: pageTitle, path: "#" }
        ]}
      />
      <ProjectOverview project={project} />
      <ProjectRequirement project={project} />
      <ProjectResult project={project} faqs={project.faqs} />
    </InnerPageLayout>
  );
}
